var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKrayzsing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 524.65 415.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-8, .cls-10, .cls-14 {\n        fill: none;\n      }\n\n      .cls-1, .cls-11 {\n        stroke: #e9e9e9;\n      }\n\n      .cls-2 {\n        fill: #676867;\n        stroke: #676867;\n      }\n\n      .cls-3 {\n        fill: #888;\n        stroke: #888;\n      }\n\n      .cls-4, .cls-5, .cls-8, .cls-9, .cls-13, .cls-14 {\n        stroke: #4c4b4c;\n      }\n\n      .cls-4, .cls-9 {\n        fill: #4c4b4c;\n      }\n\n      .cls-5 {\n        fill: #4c4c4c;\n      }\n\n      .cls-6 {\n        fill: #adacad;\n      }\n\n      .cls-6, .cls-10, .cls-12 {\n        stroke: #acacac;\n      }\n\n      .cls-7 {\n        stroke: #4d4b4d;\n      }\n\n      .cls-7, .cls-11, .cls-13 {\n        fill: #e9e9e9;\n      }\n\n      .cls-8 {\n        stroke-width: 7px;\n      }\n\n      .cls-9 {\n        stroke-width: 7px;\n      }\n\n      .cls-12 {\n        fill: #acacac;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm_Colour-2",
    "data-name": "Arm Colour-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.06,216.58s-7.03,3.64-12.27,19.09c-5.52,16.27-37.92,45.98-44.29,57.49-15.32,27.66,1.1,55.24,1.1,55.24,0,0,29.85,14.77,46.24,18.39,52.28,11.54,138.17-31.74,185.09-55.55,1.68-.85,5.9-34.5,7.47-35.3,11.71-5.93,17.88,22.52,22.36,21.11,6.43-2.03-.21,20.23,3.59,14.38,4.8-7.37,62.9,39.27,64.75,30.62,2.87-13.45,3.01-25.22,3.01-25.22l-42.2-76.96c-6.24-13.2-13.66-31.51-16.94-32.01l-112.38,73.83-105.53-65.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.95,246.87s5,35.03,2.84,41.53c-2.91,8.75-4.58,25.38-8.16-4.66,0,0-9.63,10.82-8.75,22.48s6.57,19.81,4.82,32.28-10.37,7.81-10.19,19.39c.18,11.59,22.19-8.38,22.19-8.38l20.18-3.28s-7.65-92.15-22.91-99.35h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.85,225.48s14.32-8.04,17.21,3.89,21.67,34.44,20.23,44.86,17.68,22.09,21.07,29.37-13.33,7.9-13.33,7.9l37.42,45.4s4.54-10.62,0-23.01-9.88-46.13-30.92-73.02-25.06-41.22-25.06-41.22c0,0-.11-11.78-7.48-11.78s-19.12,17.63-19.12,17.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.41,235.67s-2.65,27.2,3.1,31.49,16.18-11.57,16.18-11.57l-5.94,41.44-13.95-18.04-6.1-7.72c-.27-11.76,2.93-23.67,6.71-35.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141,223.18s3.91,8.67,1.14,15.86-9.86,26.98-9.86,26.98c0,0-3.68,2.15-5.18-8.5,0,0,1.75,18.2-5.56,23.18s-13.52,11.58-13.52,11.58l65.96-2.26-7-64.9-15.15-7.47-10.82,5.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arm_Lines-2",
    "data-name": "Arm Lines-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M370.39,207.13s2.84.41,4.55,6.86,11.88,25.26,15.46,30.64,36.22,40.38,43.76,101.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M362.87,252.95s.88,20.04-3.26,31.64-3.84,20.44-3.84,20.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M145.8,216.49s-2.85.31-4.8,6.69-12.79,24.81-16.57,30.05c-3.78,5.24-61.17,55.94-29.84,95.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M171.55,347.11s.61-10.21-7.68-23.59-6.53-36.52-6.53-36.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_Colour-2",
    "data-name": "Body Colour-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200.58 380.24 307.32 380.24 313.18 193.85 256.51 170.69 175.23 207.85 200.58 380.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M229.52,378.75s8.11-113.75,0-130.54-27.43-49.79-27.43-49.79l-26.86,9.43,29.45,197.9,24.84-27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.78,372.46s-20.76-78.71-24.78-90.86-15.24-18.99-15.24-18.99l24.6,132.04,15.41-22.19h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.9,227.8s3.64,13.76,11.12,15.65c10.18,2.58,38.52-3.7,42.63-9.88s23.15-26.97,19.56-46.84-73.32,41.07-73.32,41.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.24,378.75l54.86,3.78-1.71-61.72-36.09-62.35-14.81,2.86s7.58,15.92,7.58,22.45-9.83,94.98-9.83,94.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.02,325.5l.76,63.56,64.62-17.14s-12.29-110.54-10.68-125.64-54.7,79.22-54.7,79.22h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M194.1,202.97c-12.11,5.78-5.51,20.25.66,20.79,1.7.15,3.41-.61,4.89-1.92l-1.94-4.13c-.52.29-1.17.45-2.01.44-3.72-.08-4.58-8.03-.02-9.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M200.34,234.07c-4.15-.65-8.62-11.43-3.74-13.9l3.69-4.77c-19.38-2.99-9.74,25.85-.37,24.69,1.94-.24,3.73-.15,5.23-1.36l-2.62-4.83c-.54.24-1.25.32-2.19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M209.27,248.96c-8.32.59-11.28-9.33-8.35-12.25l4.24-6.55c-20.67,0-8.53,30.22,5.39,24.92,2-.76,3.82-1.15,5.04-2.76l-4.09-4.12c-.49.39-1.21.69-2.22.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.98,262.85c-5.46,2.7-16.83-4.97-10.78-10.14,2.6-2.18,2.74-4.82,1.62-7.69-20.98,10.29,1.55,29.81,11.95,23.45,1.95-1.2,3.61-2.24,4.46-4.17l-5.17-2.83c-.41.52-1.1.91-2.08,1.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M234.76,270.73c-4.22,2.87-17.9-.73-11.7-9.27,1.98-2.4,1.47-4.29-.66-6.16-19.55,13.7,7.93,29.87,16.32,20.18,1.63-1.88,3.25-3.12,3.73-5.22l-5.84-1.43c-.31.62-.9,1.25-1.85,1.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M298.45,208.69c-1.06-.04-3.18-1.63-5.15,1.6-1,1.64-1.17,4.06-.46,6.22.17.52.94,1.73,1.28,2.03l-5.96,1.7c-1.68-4.13-1.23-9.17.33-12.06s4.92-7.34,11.12-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M291.82,233.24c-.35-.37-1.16-1.87-1.35-2.52-.78-2.65-.75-5.65.26-7.53,3.35-6.2,6.18-3.91,7.27-4.39,1-.58,2.08-.84,2.4-4.31-5.08-5.44-13.09.92-14.57,5.92-1.11,3.73-1.77,9.54.05,14.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M282.38,248.4c-.27-.46-.75-2.16-.8-2.84-.2-2.81.48-5.71,1.91-7.23,4.69-5.02,7.01-1.96,8.19-2.11,1.12-.26,2.26-.2,3.33-3.47-3.87-6.78-14.11-.68-15.81,1.42-2.34,2.91-3.84,8.73-3.14,14.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M271.93,261.38c-.15-.53-.15-1.16-.04-1.83.45-2.77,1.2-6.43,2.92-7.45,5.67-3.35,7.71.26,8.89.5,1.14.1,2.22.52,4.01-2.28-2.16-7.76-13.43-5.13-15.55-3.64-2.93,2.06-5.72,7.19-6.31,12.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M255.97,267.8c.12-.57-.37-1.72.05-2.27,1.72-2.25,6.28-3.52,8.29-3.44,6.62.25,5.33,3.66,6.26,4.55.96.76,1.72,1.75,4.63.25,1.77-8.29-7.96-11.36-10.55-11.24-3.57.18-10.53,1.85-13.67,6.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.56,271.47c.83,4.99,12.39,4.62,15.45.54.69-.92,1.36-.63,1.45-1.31l5.82,2.73c.25,2.14,0,1.04-1.54,2.86-5.52,6.6-26.03,7.5-26.03-5.64,0-11.36,14.65-12.38,21.04-9.27,2.85,1.39,6.6,5.22,6.6,10.79l-4.58-.85c-.72-1.23-2.65-4.01-5.73-5.03-2.69-.89-9.57-1.3-11.09,1.14-.55.89-1.13,2.38-1.34,3.11l-.07.92h.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M269.59,267.15c-1.45,5.08-12.39,6.74-15.18,2.59l-5.5-2.71c-2.52,18.32,25.21,11.53,26.5.78.3-2.48-.29-1.29-1.07-3.24l-5.02.55c.11.69.6.89.27,2.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283.1,253.54c1.02,4.95-8.58,12.29-12.76,10.38l-5.13-.93c5.42,17.67,28.14-2.45,23.07-12.03-1.08-2.05-.11-.23-1.63-1.41l-4.07,2.29c.39.5.29.59.52,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M291.32,237.31c2.12,4.44-5.42,14.55-9.88,14.04l-5.16.73c9.3,15.29,26.53-11.28,19.44-18.9-1.51-1.63,1.73.65,0,0l-2.31,2.89c.5.36-2.57.24-2.09,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M298.88,219.86c2.94,3.68-3.02,15.7-7.33,16.49l-4.72,1.07c13.56,13.45,22.6-17.41,14.32-22.72-1.77-1.13,1.77.13,0,0l-2.27,5.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M299.61,203.47c11.85,5.08,4.26,30.33-8.88,19.72.88-1.71,1.94-2.94,3.15-3.8,7.97,2.16,7.59-8.95,4.23-10.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M223.58,261.5c2.23-1.82,8.35-.16,10.4,1.77,5.44,5.12,3.32,6.82,3.58,8.2.37,1.31.31,2.36,3.66,3.36,6.38-5.13-.9-14.49-3.15-16.31-3.08-2.49-9.6-4.73-14.95-3.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M212.31,251.09c2.42-1.23,8.78,2.6,10.32,4.98,4.1,6.33-.91,7.07-.93,8.48.1,1.36-.55,3.48,2.38,5.28,9.21-6.14,4.03-15.75,2.27-18.08-2.22-2.95-7.22-6.42-12.08-7.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M204,235.35c2.49-.51,6.49,4.07,7.59,6.66,3.39,7.93-.13,9.5-.13,9.5-.22,1.33-3.54,2.7-1.26,5.22,11.51-2.78,7.6-14.19,6.52-16.9-1.44-3.63-5.61-8.65-10.22-10.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M199.11,220.14c2.37.13,5.02,5.3,5.11,8.03.24,7.24-2,7.09-2.65,8.27-.54,1.18-1.19,1.91.21,4.81,6.74.42,7.88-11.08,7.61-13.87-.31-3.17-2.13-7.76-4.95-10.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M195.69,208.95c3.8-.78,5.98,2.3,5.81,4.81-.45,6.66-4.19,5.24-4.89,6.41-.6,1.16-2.43,1.92-1.42,4.42,12.25,1.01,12.21-11.1,11.68-14.1-.89-5.03-6.29-9.69-12.76-7.52"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M139.91,221.68s5.85-7.41,10.15-5.1,25.62,86.73,28.16,89.64,21.01,22.42,21.01,22.42l11.6,13.63-5.3-87.33-17.58-50.15-2.6-12.74h-9.97l-5.05,6.36s-17.12-.44-22.1,3.85-8.31,19.42-8.31,19.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M324.7,185.47l-32.29,36.22s-9.21,25-10.25,45.48-2.38,66.71-2.38,66.71l12.64-15.73s11.39-4.09,17.23-11.93,13.43-22.41,18.12-41.29,27.62-56.45,32.84-57.08,8.2-2.37,8.2-2.37c0,0-4.09-8-13.05-12.03s-31.06-7.98-31.06-7.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.45,226.76s13.19-9.48,13.53-18.91-5.89-10.95-5.89-10.95l9.21-.42,6-6.69s6.99,4.62,8.65,15.01,20.16,45.83,19.33,55.52c-.83,9.69,3.55,81.96,3.55,81.96l-11.6-13.63s-11.73-1.42-21.01-22.42c-10.94-24.78-21.76-79.46-21.76-79.46h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M288.75,226.07s32.61-36.01,39.24-34.02c6.63,1.99,23.03,25.78,17.52,37.66,0,0,10.36-20.61,15.1-21.86s8.2-2.37,8.2-2.37c0,0-5.67-10.79-10.06-13.43s-34.04-6.58-34.04-6.58l-18.95-22.1-5.53,21.77s5.56,3.58,5.28,8.71-16.76,32.22-16.76,32.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M310.93,238.11s-1.36,37.41,2.25,42.59,9.12,5.35,9.12,5.35l-12.66,20.17-27.96-31.24.47-7.82s19.51,10.69,21.28,0,7.48-29.04,7.48-29.04h.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_Lines-2",
    "data-name": "Body Lines-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M263.92,196.5s1.11-34.33,2.53-42.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M245.51,211.5s4.08-27.09,6.71-36.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M279.78,185.47s-12.63-1.82-14.59-5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M269.49,181.87s30.69-20.18,34.75-20.18,21.94,23.34,21.94,23.34c0,0,33.78,1.66,38.35,9.4s3.76,6.31,5.87,12.7c0,0-4.35,0-9.19,3.1-4.53,2.9-19.95,24.9-26.06,39.57-6.11,14.67-10.93,39.51-15.3,46.46-9.85,15.64-32.57,29.23-32.57,29.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M313.18,224.32s-11.96,40.14-11.66,64.91-22.26,45.12-22.26,45.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M296.42,202.3c.92-5,1.38-10.6,1.26-16.9,0,0-9.46-5.78-4.69-5.85s11.44,8.57,10.69,16.13c-.75,7.56-20.62,33.69-20.62,50.32s-5.83,89.42-5.62,100.43,1.08,22.46,1.08,22.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M335.89,274.22c0,10.42,7.52,60.8,8.51,93.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M224.02,207.85s-.95-34.33-2.16-42.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M239.76,222.84s-3.48-27.09-5.73-36.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M210.47,196.81s10.79-1.82,12.47-5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M219.26,193.21s-26.23-20.18-29.7-20.18-18.75,23.34-18.75,23.34c0,0-21.42-1.85-25.32,5.89s-9.35,16.18-5.81,24.29c0,0,5.58-8.69,10.09-7.64s8.16,27.56,13.38,42.24c5.22,14.67,9.34,39.51,13.08,46.46,8.42,15.64,27.84,29.23,27.84,29.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M181.92,235.67s10.22,40.14,9.97,64.91,19.02,45.12,19.02,45.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M249.57,246.06s-37.52,4.92-39.1-49.25c0,0-7.22-5.85-11.29-5.92-4.07-.07-9.78,8.57-9.14,16.13s17.62,33.69,17.62,50.32,4.98,89.42,4.8,100.43c-.18,11.02-.92,22.46-.92,22.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M155.24,262.62s7.27,12.53,7.27,22.95-6.43,60.8-7.27,93.18"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M336.85,248.21s-4.33,23.28,1.34,29.47c5.67,6.19,13.09,18.33,17.57,19.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M405.22,298.37s-30.04-15.91-40.61,7.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 281.25,
    y1: 228.15,
    x2: 275.41,
    y2: 236.38
  })), /*#__PURE__*/React.createElement("g", {
    id: "Drip-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M211.82,213.25s7.64,21.93,13.62,26.65,18.6,9.28,28.62,5.19,18.71-11.63,23.76-20c1.96-3.24,4.26-13.29,4.31-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M233.72,244.55c.57-2.74,4.28-4.94,7.59-3.77s6.03,4.72,3.92,8.96-13.19,2.92-11.51-5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M249.34,246.19c-2.13-4.5,4.03-9.09,7.84-7.57s6.01,7.06,1.94,9.5-8.05,1.72-9.78-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M263.16,239.69c-1.79-4.84,1.53-8.16,5.05-9.23,4.45-1.36,7.15,3.05,5.13,8.34-1.17,3.06-8.76,4.73-10.18.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M279.36,217.23c3.36.66,6.33,7.48,1.89,10.92s-10.93-.61-8.59-6.6c.57-1.47,2.9-5.07,6.7-4.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M280.74,203.91c3.97-.5,7.36,3.1,6.39,6.78s-5.13,6.01-8.23,2.81-2.45-9.05,1.84-9.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M220.22,240.47c-1.65-5.01,1.77-8.25,5.18-7.92s6.37,5.16,5.54,8.85c-1.25,5.56-8.94,4.49-10.73-.93h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M211.64,220.04c2.63-3.59,9.13-.52,9.84,3.72s0,8.04-4.73,7.95-8.82-6.6-5.11-11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M215.95,210.3c.2-3.51-1.3-7.34-4.89-6.91s-6.1,4.51-4.45,8.81c1.12,2.93,2.9,4.02,5.04,3.81s4.07-1.71,4.3-5.71h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Head_Colour-2",
    "data-name": "Head Colour-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168,151.8s24.07,59.7,44.12,72.12c20.05,12.42,47.35,3.68,47.35,3.68,0,0,29.73-22.21,31.36-33.05s2.84-7.84,2.84-7.84c0,0,8.84-4.03,8.31-9.2s1.85-14.37,2.64-19.56-.4-29.79-1.32-31.07-66.96-38.58-66.96-38.58l-66.31,20.54-2.04,42.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.13,216.58l1.38,5.1s26.45-3.96,27.82-5.1c1.37-1.14,12.56-9.32,12.56-9.32l-8.74-2.01s-15.26,6.96-19,8.42-14.02,2.91-14.02,2.91h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.48 142.95 205.53 157.19 172.3 164.31 172.3 156.27 200.48 142.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "224.42 211.25 226.11 216.58 251.5 208.88 258.17 203.15 240.07 208.33 224.42 211.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "245.6 205.28 247.64 209.14 258.17 203.15 245.6 205.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.35,115.06s10.55,15.5,10.17,21.75,12.28,62.69,10.17,68.45-22.19,16.43-22.19,16.43l.38,7.68s36.99-22.54,37.67-27.64,2.85-16.59,2.85-16.59c0,0,7.26.87,9.56-7.62s2.9-32.19,2.9-32.19l-6.09-21.29-45.43-8.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.48,172.21c-.15.72,1.67,23.39,1.67,23.39,0,0,6.44.61,8.39-.91s7.38-3.46,10.85-2.65l-4.18,7.36-14.15,2.85-6.24,6.88-2.44-31.63,6.09-5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.06,141.42l2.84,17.84,11.21-13.39s-4.1-1.56-2.89-4.75-11.16.3-11.16.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_Lines-2",
    "data-name": "Head Lines-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.79,67.86c-2.39.95-27.53,38.5-29.75,42.48s-9.55,31.5-9.55,31.5l15.05,20.52s-5.82-12.57-5.82-15.91,5.57-12.73,5.57-12.73c-.16-1.59-3.66-17.5-.95-23.23s36.11-15.22,36.11-15.22c0,0,36.98-4.05,42.29,1.33s3.58,14.34,3.82,18.86c0,0,9.31,5.87,15.33,10.6,6.02,4.73,9.72,3.68,10.15,21.53,0,0,7.95-13.32,9.5-18.93,11.71.87,14.08,5.46,17.1,9.8-1.47-8.28,2.85-47.08,1.69-48.32-1.66-1.77-55.42-30.05-58.48-30.05l-52.06,7.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M297.75,175.37c.97-4.91-4.36-4.05-5.4-3.08-1.78,1.67-2.27,5.4,0,6.26s4.82-.28,5.4-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M298.79,145.63s-2.75-6.98-4.91-6.08-8.2,11.09-2.78,16.55-5.65,10.83-5.03,14.59"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 245.59,
    cy: 163.84,
    rx: 21.1,
    ry: 19.09,
    transform: "translate(-23.99 43.49) rotate(-9.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.76,165.63s1.38-.39,5.14-.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 264.8,
    y1: 152.6,
    x2: 278.04,
    y2: 144.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.11,171.66c2.08,3.73,2.7,4.55,6.81,7.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 237.98,
    y1: 181.91,
    x2: 242.15,
    y2: 182.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 247.64,
    y1: 182.83,
    x2: 251.5,
    y2: 182.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 256.51,
    y1: 179.88,
    x2: 259.83,
    y2: 177.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.52,173.33c1.34-2,2.04-3.84,2.55-5.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 266.61,
    y1: 161.99,
    x2: 266.23,
    y2: 159.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.37,154.59c-2.02-3.12-3.78-4.84-4.9-5.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 255,
    y1: 146.42,
    x2: 251.71,
    y2: 145.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 246.33,
    y1: 144.68,
    x2: 242.74,
    y2: 144.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 237.35,
    y1: 146.47,
    x2: 234.43,
    y2: 147.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.92,151.54c-1.78,1.52-3.05,4.03-3.81,5.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.71,162.12s-.6,2.29-.06,4.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 274.98,
    y1: 146.11,
    x2: 270.1,
    y2: 149.22
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 192.12,
    cy: 172.93,
    rx: 19.85,
    ry: 19.09,
    transform: "translate(-26.27 34.65) rotate(-9.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.76,165.63s-1.43.09-4.88,1.62"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.91,174.08c-.65,4.19-.94,5.17-3.52,9.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 204.68,
    y1: 187.58,
    x2: 201.28,
    y2: 189.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 196.41,
    y1: 191.54,
    x2: 192.74,
    y2: 192.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 187.61,
    y1: 191.6,
    x2: 183.91,
    y2: 190.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.3,187.66c-1.83-1.46-3.04-2.98-4.07-4.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.92,
    y1: 177.92,
    x2: 172.38,
    y2: 175.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.54,170.21c.79-3.6,1.8-5.79,2.55-6.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.22,
    y1: 159.48,
    x2: 180.78,
    y2: 157.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 185.34,
    y1: 155.05,
    x2: 188.61,
    y2: 154.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 193.87,
    y1: 153.86,
    x2: 196.93,
    y2: 154.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.08,156.27c2.07.86,4,2.83,5.19,4.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.1,164.6s1.27,1.97,1.46,4.13"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.15,197.08c-4.31-.2-14.67-.61-16.3,1.22s-3.05,2.65-3.05,2.65c0,0-1.63.17-4.03-.35s-9.51,3.41-12.88,6.11c-2.52,2.02-7.36,6.96-7.36,6.96l10.97-.59.88-3.09s2.29-.83,3.17-.61,3.36-1.11,3.72-2.18c.36-1.07,6.42-3.52,6.42-3.52,0,0,6.34-1.57,7.26-.92.92.66,3.7.27,4.29-.42s2.92-1.37,2.92-1.37l2.52,1.98,15.01-3.45s-10.31-2.28-13.54-2.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M274.19,213.06c.06.52-3.71.37-4.52,2.35-.82,1.98-3.81,3.64-5.3,3.74s-3.87,2.99-4.22,4-2.15,1.14-3.85,1.81c-1.7.67-4.04,5.84-5.17,2.62s-1.09-2.91-.5-4.25.73-3.5.73-3.5l-11.53,3.15-7.94,1.4s-2.55,1.33-1.47,2.17,2.18.43,3.03,3.74.78,1.55-.72,1.83-.99.74-1.74.05-.3-4.23-1.36-3.56c-1.07.67-3.2.37-4.75-.9s-2.61,1.18-2.83.7c-1.01-2.19-8.77-5.97-9.93-4.48,0,0,19.17,16.08,30.04,14.01,4.42-.85,17.66-2.77,22.64-6.74,2.11-1.68,22.55-25.9,22.55-25.9-2.09-.53-13.44,5.38-13.16,7.78v-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.85,165.38s-3.75,5.17-5.91,12.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.53,157.96s-3.13,5.29-4.13,11.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M280.01,144.69s7.14-14.5,10.63-14.27c5.87.39,13.82.38,16.22,17.01,1.86,12.93-2.59,17.72-2.59,21.59s.22,15.56-10.61,17.69c0,0-1.82,13.37-6.32,18.57s-20.87,28.61-23.82,29.51-22.01,5.85-25.54,4.95-11.87-6.08-11.87-6.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.88,135.28c.71-.42,20.39,1.66,26.76,1.8,5.64.12,11.48,4.26,11.82,4.21,0,0-7.85-2.93-12.42-2.64s-25.87,4.22-26.72,3.23.55-6.6.55-6.6h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.38,157.19s2.35-3.24,7.11-5.39,21.16-6.26,21.08-7.65-.92-5.94-2.25-5.47c-1.17.41-4.56,5.98-16.4,10.33-3.59,1.32-9.55,8.18-9.55,8.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M222.9,210.49s6.96.16,11.21-1.72,20.65-7.34,25.72-6.4c5.07.94,12.7,4.01,12.7,4.01,0,0-6.26,8.64-14.36,11.61s-27.5,5-28.65,5-6.62-12.49-6.62-12.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M226.11,216.58s16.84-3.75,21.53-5.78,13.51-7.65,13.51-7.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 186.98,
    y1: 194.53,
    x2: 188.91,
    y2: 198.41
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand_Colour-2",
    "data-name": "Hand Colour-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.19,405.36c0-.57-11.36-28.66-10.43-37.1s.94-20.61.94-20.61c0,0,9.11-14.22,9.49-14.41s-.37-26.06,3.04-29.64,15.27-4.04,15.27-4.04l5.98-7.46,24.09-7.1s18.23-20.17,18.61-31.8l12.56-2.89,14.23-4.72,6.93-10.35s8.97-4.1,13.15,2.35c4.18,6.45,3.89,11.89,3.89,11.89l-4.46,5.95,2.09,10.83-7.02,13.34-3.04,4.11v7.21l-6.38,2.22.91,11.83-6.74,4.38-3.32-3.5s-1.45,6.71-5.11,8.03l-3.65,1.33-.57,8.24.64,6.26s1.9,11.3-1.55,15.48-16.17,20.69-16.17,20.69c0,0-4.55,26.38-7.21,28.09s-12.52,15.37-30.74,16.7-25.43-5.31-25.43-5.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.88,315.81l-1.38,6.42,18.25,2.08s21.27-3.87,21.25-4.25-4.02,8.22-1.7,11.66,21.55,9.06,21.55,9.06l1.23,11.64,10.86,2,32.16-11.91s-1.06,9.93,1.98,13.43,13.46,1.86,13.46,1.86c0,0,8.34,6.35,10.44,5.95s8.08-1.74,8.08-1.74c0,0,38.01,11.46,43.5,9.87s18.6-2.78,22.57-2.38,19.79,3.9,25.88-4.8-.06-26.99-.06-26.99l-22.25-6.5s-13.46-21.33-20.05-19.27-5.16,5.95-10.72,3.77-5.56-7.94-11.12-7.74-12.04,0-12.04,0l-7.22-9.52-9.32,1.22-14.9-7.77-11.68,8.7s-5.39,3.05-9.36-2.03-7.34-14.76-12.9-18.95-20.11-21.29-29.49-28.8c0,0-4.15,6.98-1.05,13.92s9.49,19.7,9.49,24.78-14.68,11.53-19.85,14.11-25.41,10.39-31.56,11.25-14.09.96-14.09.96l.04-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.29,241.61l-.44-12.81s8.37-23.34,12.33-25.29,19.24-6,19.24-6c0,0,15.83,5.34,18.22,8.65s8,12.91,8.47,16.94-13.2,27.06-17.49,31.11c-2.59,2.44-13.88.92-13.88.92l4.86-6.81s-.53-10.12-3.67-12.7-13.91-3.29-19.2-1.65l-3,6.62-5.44,1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.29,253.21h8.42s5.38,13.53,7.41,13.06,6.44,0,6.44,0l-7.02,13.34-5.5-3.4,4.44-7.23-7.46-11.45-4.3,1.97-2.44-6.29h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.87,274.33c-.04-.15,11.29,12.25,13.87,10.68s9.81-5.41,9.81-5.41l-3.04,11.33-6.38,2.22-2.08-3.65-5.92-3.45-6.25-11.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.05,289.5s-.34,2.13-1.26,4.99-8.31,4.76-11.17,3.95l8.68,10.92,6.74-4.38-2.99-15.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.45,311.42c.55.5,8.42,2.47,8.42,2.47l3.93-4.53-4.71-5.75-7.64,7.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.14,313.96s-9.23,7.74-13.5,5.08-5.44-7.63-5.44-7.63c0,0,3.11,10.06,2.82,12.56s-2.82,6.49-2.82,6.49c0,0,20.58,1.26,23.69-2.04s4.92-8.54,4.92-8.54l-9.67-5.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.82,332.5s3.43,3.18,0,6.16c0,0,.36,6.47-1.49,9,0,0-4.27,16.11-9.13,18.64s-26.8,2.91-37.48-8.16c0,0,21.56,21.94,17.87,28.74-3.69,6.8-23.41,18.49-23.41,18.49,0,0,10.59,8.3,21.46,5.49s32.63-6.69,33.7-19.31,11.47-31.03,13.01-32.43,18.18-14,13.8-24.77-2.42-15.29-2.42-15.29l-6.25-.56-19.67,14.01h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.08 292.29 108.02 298.55 107.71 309.36 120.08 292.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.5,322.23s16.02.64,19.57-.56,34.55-12.37,37.82-12.36c3.27.01,1.96,8.76,1.96,8.76,0,0-10.89.04-19.85,1.99s-21.25,4.25-21.25,4.25l-18.25-2.08h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "235.79 329.72 249.36 327.78 245.14 322.23 238.19 325.21 235.79 329.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.26,331.32s5.02,7.5,20.85,10.72c0,0-1.48-3.66-1.18-5.36s-17.89-6.84-19.67-5.36h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "255.16 347.65 263.85 351.03 268.27 354.16 256.94 352.42 255.16 347.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.12,337.7s-5.66-4.8-12.15-3.37-37.12,16.7-37.12,16.7l6.1,3.38,33.51-13.73,9.65,2.91v-5.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.94,252.95s12.38,13.06,14.53,16.34,14.27,13.15,15.25,16.49,7.39,10.08,14.79,11.33l-12.2-14.68-13.74-14.9-16.49-16.74-2.15,2.15h.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.11,342.5s-3.8,9.35,1.98,13.43,13.46,1.86,13.46,1.86c0,0,7.47,4.21,10.44,5.95s8.08-1.74,8.08-1.74c0,0,23.83,10.18,33.67,10.03s16.79-1.6,20.42-1.95,33.3,4.65,36.18-.09c9.61-15.83,1.81-39.92,1.81-39.92,0,0-9.38-10.18-15.89-6.61-7.13,3.91-5.61,38.03-10.07,35.18-17.07-10.91-22.62-38.33-22.62-38.33,0,0,5.27,30.65-5.64,32.11s-21.8-11.64-21.8-11.64c0,0-7.58,11.09-14.85,5.52s-16.43-6.34-16.43-6.34l-18.76,2.55h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M149.77,293.53s-14.95,14.74-5.6,19.3c6.11,2.98,16.98,3.47,16.98,3.47,0,0-4.08-.83-2.51-5.44s4.25-9.28,4.25-9.28h2.51l-4.11-3.03s-1.44-4.14-.85-5.41,8.36-8.14,8.36-8.14l-6.65-5.41s1.47-4.48,3.71-6.72,4.84-2.49,4.84-2.49l-4.24-5.67s-5.7,1.8-6.73,4.75-2.13,8.21-2.13,8.21c0,0-7.66,1.94-7.84,6.06s0,9.8,0,9.8h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.17,245.14s-1.85,10.76,1.72,15.17,9.43,3.4,9.43,3.4l6.42-.99s-3.81-1.83-4.76-4.51,0-12.6,0-12.6l4.76-.46-.74-2.14-16.83,2.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M182.94,244.15l4.81-8s4.78-1.27,6.3,1.46l-5.73,10.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 197.82,
    y1: 241.9,
    x2: 191.55,
    y2: 252.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M161.72,258.2l11.92-2s.79,5.59,3.08,5.25l2.29-.34s-8.95,2.92-11.2,2.58-6.08-5.5-6.08-5.5h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 160.21,
    y1: 252.38,
    x2: 173.29,
    y2: 249.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "159.74 269.47 164.87 274.33 163.95 277.67 157.75 274.97 159.74 269.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "149.21 288.03 160.44 293.14 159.74 295.5 149.77 293.53 149.21 288.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 153.49,
    y1: 279.3,
    x2: 165.76,
    y2: 286.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.61,309.8c.32.11,9.74,2,9.74,2l3.79,4.5-16.98-3.47,3.44-3.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.62,304.26s-2.5,7.91,0,13.82,5.47,7.04,5.47,7.04l12.2-4.28s-7.14-6.44-7.5-11.02,3.82-7.49,3.82-7.49l-14,1.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M247.69,318.56l-.46,3.84s-5.93,5.56-5.46,7.32,1.63,6.82,1.63,6.82l5.22,2.64,2.57,9.64,5.13,1.94v-6.52l-5.13-3.56s-1.3-5.98,0-8.17,3.98-5.3,3.98-5.3c0,0-2.38-.52-2.69-2.01s1.36-6.64,1.36-6.64h-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M225.62,318.07l12.58-3.22s1.53,5.97,5.09,5.97-12.2,4.28-12.2,4.28l-5.47-7.04h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 224.32,
    y1: 312.83,
    x2: 237.26,
    y2: 309.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "241.74 331.39 251.97 334.07 251.97 338.92 243.4 336.55 241.74 331.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "248.62 339.18 251.19 348.82 256.94 352.42 256.32 344.24 248.62 339.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 244.59,
    y1: 325.11,
    x2: 254.74,
    y2: 328.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M321.19,314.85s-8.04,4.11-8.07,8.61,9.18,10.88,9.18,10.88l-1.11-19.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M318.34,305.78v5.63s3.28.16,3.12,0-3.12-5.63-3.12-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.66,334.07s-4.37,8.34-4.57,8.64,7.46,2.5,7.46,2.5l2.92-6.89-5.81-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M311.8,324.59s8.21,3.45,10.5-.62.83-7.17.83-7.17l-.83,17.53s-7.79-1.44-10.5-9.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand_Lines-2",
    "data-name": "Hand Lines-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M128.57,285.01s-18.53,0-25.6,7.1c-5.6,5.62-5.55,7.84-5.41,11.61s-8.25,2.68-7.63,10,11.82,30.65,25.59,34.88c10.07,3.1,42.69-1.57,42.79-10.34.1-8.78.23-7.21.23-7.21,0,0,5.04-6.36,3.23-13.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M153.38,317.59s1.49,7.94-6.13,10.89c-27.62,10.69-45.05-6.93-38.68-30.18,2.2-8.05,15.09-6.19,15.09-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M98.5,297.59c-3.14.28-11.29,0-16.17,5.87-6.91,8.32-1.58,48.49-2.46,53.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M160.74,327.22c10.53,16.34-9.13,30.67-11.88,34.41-8.25,11.22-10.28,29.19-10.28,29.19,0,0-.25,13.94-29.25,21.23-23.4,5.89-32.98-3.55-32.98-3.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M71.45,376.59s-5.97-24.6-1.44-31.04c3.13-4.45,9.03-18.33,9.03-18.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M179.97,245.14s-1.19-3.58-2.2-3.43-16.61,3.43-16.61,3.43c0,0-2.1,4.25-2.11,8.65,0,4.8,4.1,8.62,7.76,10.92l11.92-.24s2.24-1.13,2.17-2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.74,259.02c-1.79,3.34-5.03-.05-4.75-7.62.21-5.63,1.61-6.66,3.07-5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M164.11,279.6s.05-2.14,1.88-5.25c1.92-3.28,7.31-4.33,7.31-4.33l-9.07-6.32s-7.66,2.84-7.77,11.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M161.08,297.12s.53-4.48,2.7-7.34,7.34-5.06,7.34-5.06l-14.44-9.75s-4.41,3.29-6.84,6.45c-2.91,3.79-.67,11.72-.67,11.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M163.95,302.32s-11.24,8.55-1,13.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M166.38,302.76c.56-2.53-1.77-4.33-1.77-4.33l-16.02-5.29s-5.09,1.71-7.39,8.81c-1.69,5.2.15,10.27,1.2,12.6l17.35,4.01s2.51-.36,3.2-2.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M158.95,312.83c3.33-.27,6.88-9.2-1.17-13.91-5.8-3.39-15.29-2.18-16.72,5.22-.81,4.21,3.23,7.71,3.23,7.71,1.24.02,3.75-1.82,4.8-2.27,0,0-5.26-6.97,2.11-6.37,3.87.31,6.27,3.82,3.98,6.41l3.76,3.21h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M307.66,300.23s9.09-12.62,14.22-10.49c5.13,2.14,7.87,7.29,11.43,8.56s5.45-4.03,12.25-1.25,12.32,31.29,9.42,38.25-19.3,33.12-27.7,30.58c-8.4-2.53-10.06-6.59-10.06-6.59,0,0-7.12,2.51-13.08-1.26-5.96-3.77-3.33-15.15-3.33-15.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M313.46,301.71s2.53-6.59,6.55,3.88c10.08,26.22-2.48,43.06-7.52,44.65-9.15,2.9-6.67-7.35-6.67-7.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M351.8,306.86s5.38-1.92,12.81-.65,8.17,9.4,14.47,7.79,4.09-4.97,9.11-4.06c10.09,1.82,19.16,21.26,19.16,21.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M335.27,362.7s35.08,14.82,48.26,10.31c13.18-4.5,26.12.26,34.73-.49,13.62-1.18,15.9-12.29,15.9-25.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M224.32,303.6l15.48-4.04s3,.7,3.49,2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M246.36,318.84s.32,2.59-.69,2.75-15.39,4.51-15.39,4.51c0,0-5.9-5.2-6.92-9.49-1.44-6.05.33-10.48.96-13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240.86,303.73c-2.17-.9-4.21,2.59-1.69,9.73,1.88,5.31,5.41,6.38,6.37,4.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M317.32,303.6s-13.89-4.46-15.81-6.48-7.05-12.03-9.74-14.68-10.38-9.2-15.63-16.17c0,0-12.37-12.73-17.14-16.77,0,0-5.59-.16-5.59,8.71s3.56,10.29,5.59,13.45,7.41,14.45,4.47,18.15-25.27,16.06-25.27,16.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M242.83,317.6s10.71-1.81,13.06,1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M221.71,310.87s-.91.85-7.04,2.18c-5.33,1.16-13.63,1.28-15.43,3.26-3.86,4.27-2.09,7.07-2.09,7.07,0,0,15.3,2.88,20.75,2.72,0,0,8.97-1.19,10.22-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M236.85,323.98s-3.08,5,.84,10.21c1.86,2.48,6.64,3.82,9.54,4.47,0,0,.09,8.08,3.56,11.85,1.04,1.14,19.31,5.42,19.31,5.42,0,0,25.44-10.8,30.71-13.04,5.27-2.24,16.51,3.24,16.51,3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M177.05,246.12c4.31-.73,7.48-1.15,7.95-.91,1.7.85,12.94,19.09,12.94,21.42s-6.58,12.3-6.58,12.3l-2.58,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M108.02,311.91c2.56-2.87,10.17-14.32,10.17-14.32,7.64-3.61,29.06-45.6,29.06-45.6.21-.07,7.01-1.41,12.39-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M172.28,270.39c4.56,3.59,10.11,6.93,15.48,7.48,0,0,.42,12.3-1.91,15.27l-5.21,1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M171.12,286.24c2.58,1.53,5.07,2.88,7.09,3.72,0,0,4.24,14.21,3.39,15.91s-7.85,5.73-9.02,4.88l-2.74-3.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M165.91,302.9s6.37,2.95,2.92,9.01c-1.23,2.15-2.63,3.43-4.74,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M149.77,317.29s-3.8,8.68-15.26,7.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 137.21,
    y1: 331.26,
    x2: 139.5,
    y2: 324.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M177.05,258.52c.84-.27,1.53-.38,1.96-.28,0,0,4.05,7.35,6.5,9.59l-3.78,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M260.44,342.89s-6.6-2.54-13.21-4.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M259.09,327.99s-9.75-5.08-15.8-5.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M254.74,319.04s-1.09,2.68-.34,5.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M245.14,323.46s-7.35,2.51-3.37,12.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.85,327.99s-9,1.53-3.71,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.85,342.89s-2.74,3.77,1.23,9.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M322.27,335.99s-12.08-3.07-11.31-12.21,9.15-10.18,11.34-10.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M314.66,332.51s-1.92,6.82-6.98,10.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M317.32,301.03l-2.22-.45c3,3.36,2.41,13.02,2.41,13.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M175.74,241.45l3.98-5.81s8.91-3.33,14.51,0,5.65,11.67,5.65,11.67l-6,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M170.29,241.61s-3.57-7.94-2.17-13.69,11.37-25.21,20.11-29.21c5.6-2.56,16.64-5.15,27.39,1.51,5.93,3.67,14.65,16.59,13.47,24.37-1.82,11.96-12.86,28.75-18.46,31.33-5.6,2.58-13.56,1.29-13.56,1.29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12-2",
    "data-name": "Layer 12-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M315.89,125.06c.96-1.16,7.65-16.73,12.72-10.27s1.28,23.69,8.4,23.97,12.24-31.92,12.24-31.92c0,0,1.05,65.55-11.07,63.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M354.06,124.86s16.33-5.93,16.93-12.94-9.07-4.4-11.63-1.51-6.54,23.96,11,15.93c11.97-5.48,9.57-13.69,9.57-13.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M391.62,101.71s-6.01-4-10.15,3.84c-4.13,7.84.91,18.23,4.36,14.94s8.58-23.57,8.58-23.57c0,0-4.45,17.47,4.81,18.03s13.46-10.17,13.46-10.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M412.51,96.12c2.96-4.52,7.69-8.08,12.54-3.52,4.85,4.56,11.32,2.21,11.66-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M359.44,149.7c.96-1.16,7.65-16.73,12.72-10.27,5.07,6.46,1.28,23.69,8.4,23.97s12.24-31.92,12.24-31.92c0,0,1.05,65.55-11.07,63.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M397.61,149.51s16.33-5.93,16.93-12.94-9.07-4.4-11.63-1.51-6.54,23.96,11,15.93c11.97-5.48,9.57-13.69,9.57-13.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M435.16,126.36s-6.01-4-10.15,3.84c-4.13,7.84.91,18.23,4.36,14.94s8.58-23.57,8.58-23.57c0,0-4.45,17.47,4.81,18.03s13.46-10.17,13.46-10.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M456.06,120.76c2.96-4.52,7.69-8.08,12.54-3.52s11.32,2.21,11.66-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M402.32,176.95c.96-1.16,7.65-16.73,12.72-10.27s1.28,23.69,8.4,23.97,12.24-31.92,12.24-31.92c0,0,1.05,65.55-11.07,63.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M440.5,176.75s16.33-5.93,16.93-12.94-9.07-4.4-11.63-1.51c-2.55,2.89-6.54,23.96,11,15.93,11.97-5.48,9.57-13.69,9.57-13.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M478.05,153.6s-6.01-4-10.15,3.84c-4.13,7.84.91,18.23,4.36,14.94,3.46-3.29,8.58-23.57,8.58-23.57,0,0-4.45,17.47,4.81,18.03s13.46-10.17,13.46-10.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M498.95,148.01c2.96-4.52,7.69-8.08,12.54-3.52s11.32,2.21,11.66-2.17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrayzsing);
export default __webpack_public_path__ + "static/media/krayz sing.06855382bfc6e3237516b969460f9bbf.svg";
export { ForwardRef as ReactComponent };